export * from './cadastro-contrato';
